import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { Row, Col, Nav, Tab, Accordion, Card, Button } from "react-bootstrap";

import ReCAPTCHA from "react-google-recaptcha";
import RV from "simple-react-validator";
import * as CONFIG from "./_config";
import ls from "local-storage";
import {
  GoogleMap,
  LoadScript,
  Marker,
  InfoWindow,
} from "@react-google-maps/api";

toast.configure();
const axios = require("axios");

const MapContainer = (props) => {
  const mapStyles = {
    height: props.h,
    width: "100%",
  };

  const info = {
    name: props.store.ClientStoreName,
    location: {
      lat: props.store.Latitude,
      lng: props.store.Longitude,
    },
  };

  const [selected, setSelected] = useState({});
  const onSelect = (item) => {
    setSelected(item);
  };

  //AIzaSyD3pU6z1bHsSHoWouPiH6PhzCInGWxyVA8
  return (
    <LoadScript googleMapsApiKey="AIzaSyD3pU6z1bHsSHoWouPiH6PhzCInGWxyVA8">
      <GoogleMap mapContainerStyle={mapStyles} zoom={13} center={info.location}>
        <Marker
          key={props.store.name}
          position={info.location}
          onClick={() => onSelect(info)}
        />
        {selected.name && (
          <InfoWindow
            position={selected.location}
            clickable={true}
            onCloseClick={() => setSelected({})}
          >
            <p>{selected.name}</p>
          </InfoWindow>
        )}
      </GoogleMap>
    </LoadScript>
  );
};

class Contact extends React.Component {
  constructor(props) {
    super(props);
    this.validator = new RV();
    this.validator.visibleFields = [];
    this.state = {
      formControls: {},
      stores: [],
      storesGroups: null,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.Stores();
      ls.set("redirectTo", window.location.href);
    }
  }

  componentDidMount() {
    this.Stores();
    ls.set("redirectTo", window.location.href);
  }

  changeHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    this.setState({
      formControls: { ...this.state.formControls, [name]: value },
    });
  };

  formatPhoneNumber(phoneNumberString) {
    var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      var intlCode = match[1] ? "+1 " : "";
      return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join("");
    }
    return "";
  }

  Stores() {
    var ClientStores = ls.get("ClientStores");

    /*
      HR:2021-05-20
      Buche foods asked to add static locations only on the "Location" page 
      which shouldn to appear on website or any other place. 
      so we made separate API for fetching stores 
    */

    let IsBucheFoods = CONFIG.DATA.BACKEND_HOST == "buchefoods";

    if (false && !IsBucheFoods && ClientStores) {
      this.setState({ stores: ClientStores });
    } else {
      const data = new FormData();
      data.append("method", "POST");
      var apiurl;
      let reqheaders = {};

      if (IsBucheFoods) {
        // data.append(
        //   "apiurl",
        //   `https://clientsupport.rsaamerica.com/Services/SSWebRestApi.svc/GetStaticClientStores`
        // );
        apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetStaticClientStores`;
        data.append("ClientDbName", CONFIG.DATA.RSA_CLIENT_DB_NAME);
        data.append("ClientId", CONFIG.DATA.RSA_CLIENT_ID);
        data.append("ClientStoreId", 0);
        data.append("Token", "");
        reqheaders = { domainname: "clientsupport" };
      } else if (CONFIG.DATA.LOAD_STORE_FROM_DIFFERENT_URL) {
        // data.append(
        //   "apiurl",
        //   `https://${CONFIG.DATA.RSA_SUBDOMAIN}.rsaamerica.com/Services/SSWebRestApi.svc/GetclientStoresbyClientapp/${CONFIG.DATA.RSA_CLIENT_STORE_GROUP_ID}/''`
        // );
        apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetclientStoresbyClientapp/${CONFIG.DATA.RSA_CLIENT_STORE_GROUP_ID}/''`;
        reqheaders = { domainname: CONFIG.DATA.RSA_SUBDOMAIN };
      } else {
        // data.append(
        //   "apiurl",
        //   `https://${CONFIG.DATA.RSA_SUBDOMAIN}.rsaamerica.com/Services/SSWebRestApi.svc/GetClientStores/1`
        // );
        apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetClientStores/1`;
        reqheaders = { domainname: CONFIG.DATA.RSA_SUBDOMAIN };
      }

      var object = {};
      data.forEach((value, key) => (object[key] = value));
      var jsonData = JSON.stringify(object);

      axios
        .post(apiurl, jsonData, {
          headers: reqheaders,
        })
        .then((res) => {
          ls.set("ClientStores", res.data.GetClientStores);

          var hasSectionName = false;
          if (
            res.data.GetClientStores &&
            res.data.GetClientStores != null &&
            res.data.GetClientStores.length > 0
          ) {
            hasSectionName =
              res.data.GetClientStores[0].SectionName != null &&
              res.data.GetClientStores[0].SectionName.length > 0;
          }
          if (hasSectionName) {
            // console.log("hasSectionName")
            const groupByKey = (list, key) =>
              list.reduce(
                (hash, obj) => ({
                  ...hash,
                  [obj[key]]: (hash[obj[key]] || []).concat(obj),
                }),
                {}
              );
            let storesGroupsList = groupByKey(
              res.data.GetClientStores,
              "SectionName"
            );
            // console.log('storesGroupsList', storesGroupsList);
            this.setState({
              stores: res.data.GetClientStores,
              storesGroups: storesGroupsList,
            });
          } else {
            this.setState({ stores: res.data.GetClientStores });
          }
        })
        .catch(function (response) {
          console.log(response);
        });
    }
  }

  handleChange = (value) => {
    this.setState({
      formControls: { ...this.state.formControls, Captcha: value },
    });
  };

  asyncScriptOnLoad = () => {
    // this.setState({ callback: "called!" });
    // console.log("scriptLoad - reCaptcha Ref-", this._reCaptchaRef);
  };

  Contact = async (e) => {
    // console.log(this.state.formControls);
    e.preventDefault();
    const datails = this.state.formControls;
    var body = "<table> &&& </table>";
    var tr = "";

    if (!this.validator.allValid()) {
      this.validator.showMessages();
      this.forceUpdate();
      return false;
    }

    for (let [key, value] of Object.entries(datails)) {
      if (key !== "Captcha")
        tr += "<tr><td>" + key + " : </td><td>" + value + "</td></tr>";
    }

    body = body.replace("&&&", tr);

    const data = new FormData();
    data.append("method", "POST");
    const apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/SendEmail`;

    if (this.props && this.props.location.search === "?debug=1") {
      data.append("EmailId", "keyur@rsaamerica.com");
    } else {
      data.append("EmailId", CONFIG.DATA.CONTACTUS_EMAIL);
    }

    //console.log(CONFIG.DATA.CONTACTUS_EMAIL);return;
    data.append("EmailSubject", "Enquiry via Contact Us");
    data.append("EmailBody", body);
    data.append("RSAClientId", "XXX");
    data.append("EnterpriseId", "CE6693D83B834CEAB4FA533E604EE58B");
    data.append("SecurityKey", "7C9EF435200042FD953733EBF85B1A3D");
    data.append("CCList", "");
    data.append("BccList", "");

    if (CONFIG.DATA.FROM_EMAIL_ID) {
      data.append("FromEmailId", CONFIG.DATA.FROM_EMAIL_ID);
    } else {
      data.append("FromEmailId", "clientsupport@rsagroceryapp.com");
    }
    data.append("FromName", CONFIG.DATA.RSA_CLIENT_APP_NAME);
    var object = {};
    data.forEach((value, key) => (object[key] = value));
    var jsonData = JSON.stringify(object);

    axios
      .post(apiurl, jsonData, {
        headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
      })
      .then((res) => {
        if (res.data.ErrorMessage.ErrorCode === 1) {
          this.setState({
            formControls: {},
          });
          window.grecaptcha.reset();
          toast.success("An email has been sent!");
          document.getElementById("contactForm").reset();
        }
      })
      .catch(function (response) {
        console.log(response);
      });
  };

  render() {
    const Name = "Locations";

    return (
      <div>
        <div className="main-container contact-page pt-2 mt-2">
          {CONFIG.DATA.THEME == 2 ? (
            <section
              id="apus-breadscrumb"
              className="breadcrumb-page apus-breadscrumb"
              style={{ backgroundColor: "#f3ffd9" }}
            >
              <div className="container">
                <div className="wrapper-breads">
                  <div className="wrapper-breads-inner">
                    <div className="breadscrumb-inner">
                      <h2 className="bread-title">{Name}</h2>
                      <ol className="breadcrumb">
                        <li>
                          <a href="/">Home</a>
                        </li>
                        <li>
                          <span className="active">{Name}</span>
                        </li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          ) : (
            <div className="title-breadcrumb">
              <div className="container">
                <div className="title-breadcrumb-inner">
                  <header className="entry-header">
                    <h1 className="entry-title">Contact</h1>
                  </header>

                  <div className="breadcrumbs">
                    <Link to="/">Home</Link>
                    <span className="separator">/</span>
                    <span> Contact</span>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="container-fluid">
            <div className="page-content">
              <article
                id="post-267"
                className="post-267 page type-page status-publish hentry"
              >
                {CONFIG.DATA.THEME == 2 ? (
                  <div className="entry-content">
                    <div className="vc_row wpb_row vc_row-fluid full-width">
                      <div
                        style={{
                          maxWidth: "95%",
                          textAlign: "left",
                        }}
                        className="row-container"
                      >
                        <div className="contact-form wpb_column vc_column_container">
                          <div className="vc_column-inner pt-3 mr-3">
                            <div
                              className="wpb_wrapper"
                              style={{ marginRight: "-50px" }}
                            >
                              {this.state.stores != null &&
                                this.state.stores.length > 0 ? (
                                <Tab.Container
                                  id="left-tabs-example"
                                  defaultActiveKey="0"
                                >
                                  <Row>
                                    <Col
                                      sm={this.state.stores.length == 1 ? 1 : 3}
                                      className="rmpassing"
                                      style={{ paddingRight: "0px" }}
                                    >
                                      <Nav
                                        style={{
                                          color: "#666",
                                          // marginLeft: "40px"
                                        }}
                                        className="flex-column"
                                      >
                                        {this.state.stores.map((val, index) => {
                                          return (
                                            <Nav.Item
                                              key={index}
                                              style={
                                                this.state.stores.length == 1
                                                  ? { opacity: 0 }
                                                  : {}
                                              }
                                            >
                                              <Nav.Link eventKey={index}>
                                                <span className="vc_tta-title-text">
                                                  {val.City}
                                                </span>
                                              </Nav.Link>
                                            </Nav.Item>
                                          );
                                        })}
                                      </Nav>
                                    </Col>
                                    <Col
                                      sm={
                                        this.state.stores.length === 1 ? 9 : 8
                                      }
                                      style={{
                                        borderColor: "#fbfbfb",
                                        // backgroundColor: "#f8f8f8",
                                        paddingTop: "10px",
                                        paddingBottom: "0px",
                                        textAlign: "center",
                                        float: "length",
                                      }}
                                    >
                                      <Tab.Content className="contact-us">
                                        {this.state.stores.map((val, index) => {
                                          return (
                                            <Tab.Pane
                                              eventKey={index}
                                              key={index}
                                            >
                                              <div className="row">
                                                <div className="col-md-4">
                                                  <h2>{val.City} </h2>
                                                  <p
                                                    style={{
                                                      marginBottom: "-4px",
                                                    }}
                                                  >
                                                    {val.AddressLine1}
                                                  </p>
                                                  <p
                                                    style={{
                                                      marginBottom: "-4px",
                                                    }}
                                                  >
                                                    {val.City +
                                                      ", " +
                                                      val.AddressLine2 +
                                                      " " +
                                                      val.ZipCode}
                                                  </p>
                                                  <p
                                                    style={{
                                                      marginBottom: "-4px",
                                                    }}
                                                  >
                                                    <a
                                                      href={
                                                        "tel:" +
                                                        val.StorePhoneNumber
                                                      }
                                                    >
                                                      {this.formatPhoneNumber(
                                                        val.StorePhoneNumber
                                                      )}
                                                    </a>
                                                  </p>
                                                  <p
                                                    style={{
                                                      marginBottom: "-4px",
                                                    }}
                                                  >
                                                    <a
                                                      href={
                                                        "mailto:" +
                                                        val.StoreEmail
                                                      }
                                                    >
                                                      {val.StoreEmail}
                                                    </a>
                                                  </p>
                                                  <p
                                                    style={{
                                                      marginBottom: "-4px",
                                                    }}
                                                  >
                                                    <b>HOURS: </b>
                                                    {val.StoreTimings}
                                                  </p>
                                                </div>

                                                <div
                                                  className="col-md-8 myifreme"
                                                  style={{
                                                    height: 480,
                                                    borderTop:
                                                      "0px solid lightgray",
                                                  }}
                                                >
                                                  <MapContainer
                                                    store={val}
                                                    h="480px"
                                                  />
                                                </div>
                                              </div>
                                            </Tab.Pane>
                                          );
                                        })}
                                      </Tab.Content>
                                    </Col>
                                  </Row>
                                </Tab.Container>
                              ) : (
                                <div className="content">
                                  <div className="overlay">
                                    <div className="overlay-content">
                                      <img
                                        style={{ maxWidth: "none" }}
                                        src="/assets/images/loading.gif"
                                        alt="Loading..."
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="mt-3">
                        <div
                          className="pt-3"
                          style={{
                            background:
                              'url("/assets/images/bg-sub.png") no-repeat',
                          }}
                        >
                          <div className="container">
                            <div
                              className="vc_row wpb_row vc_row-fluid vc_row-has-fill "
                              style={{
                                position: "relative",
                                boxSizing: "border-box",
                                textAlign: "left",
                              }}
                            >
                              <div className="wpb_column vc_column_container">
                                <div className="vc_column-inner">
                                  <div className="wpb_wrapper">
                                    <div className="widget-newletter  ">
                                      <div className="row">
                                        <div className="col-sm-12 col-md-7 col-xs-12">
                                          <h3 className="title">
                                            Subscribe To Our Newsletter
                                          </h3>
                                          <div className="description">
                                            Sign up with your email to get
                                            updates about new resources releases
                                            and special offers
                                          </div>
                                        </div>
                                        <div className="col-sm-12 col-md-5 col-xs-12  ">
                                          <div className="content1 pt-2">
                                            <form
                                              id="SubscribeForm"
                                              className="mc4wp-form mc4wp-form-150 theme-2"
                                              method="post"
                                              encType="multipart/form-data"
                                              action="/"
                                              noValidate="novalidate"
                                              style={{}}
                                            >
                                              <div className="mc4wp-form-fields">
                                                <div
                                                  id="wpforms-8447-field_1-container"
                                                  className="input-group"
                                                  data-field-id={1}
                                                >
                                                  <input
                                                    type="email"
                                                    id="tbEmail"
                                                    className="form-control"
                                                    name="email"
                                                    placeholder="Enter your email..."
                                                    onChange={
                                                      this.changeHandler
                                                    }
                                                  />
                                                  <span className="input-group-btn">
                                                    <input
                                                      className="btn btn-theme news_letter_subscriber"
                                                      type="submit"
                                                      value="Subscribe"
                                                      name="wpforms[submit]"
                                                      id="wpforms-submit-8447"
                                                      data-alt-text="Sending..."
                                                      data-submit-text="Submit"
                                                      onClick={(e) =>
                                                        this.Subscribe(e)
                                                      }
                                                    />
                                                  </span>
                                                  <span className="text-white">
                                                    {this.validator.message(
                                                      "email",
                                                      this.state.formControls
                                                        .email,
                                                      "required|email"
                                                    )}
                                                  </span>
                                                </div>
                                              </div>
                                            </form>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="vc_empty_space"
                                      style={{ height: "50px" }}
                                    >
                                      <span className="vc_empty_space_inner"></span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="container"
                          style={{ marginTop: "-77px" }}
                        >
                          <div className="row col-md-12">
                            <div className="col-sm-12 col-md-12">
                              <div className="contact-infor wpb_column vc_column_container  vc_col-has-fill">
                                <div className="vc_column-inner">
                                  <div className="wpb_wrapper">
                                    <div className="wpb_text_column wpb_content_element ">
                                      <div className="wpb_wrapper text-center">
                                        <h2>Contact Us By Email !</h2>
                                        {/* <p>Fill out the form below to recieve a free and confidential intial consultation.</p> */}
                                      </div>
                                    </div>
                                    <div
                                      className="wpforms-container wpforms-container-full"
                                      id="wpforms-8462"
                                    >
                                      <form
                                        id="contactForm"
                                        className="wpforms-validate wpforms-form text-left"
                                        data-formid="8462"
                                        method="post"
                                        encType="multipart/form-data"
                                        action="/contact/"
                                        noValidate="novalidate"
                                      >
                                        <div className="wpforms-field-container">
                                          <div
                                            id="wpforms-8462-field_0-container"
                                            className="wpforms-field wpforms-field-name wpforms-one-half wpforms-first"
                                            data-field-id="0"
                                          >
                                            <label
                                              className="wpforms-field-label"
                                              htmlFor="wpforms-8462-field_0"
                                            >
                                              First Name
                                              <span className="wpforms-required-label">
                                                *
                                              </span>
                                            </label>
                                            <input
                                              type="text"
                                              id="wpforms-8462-field_0"
                                              className="wpforms-field-large wpforms-field-required"
                                              name="firstname"
                                              onChange={this.changeHandler}
                                            />
                                            <div className="text-danger text-left ">
                                              {this.validator.message(
                                                "firstname",
                                                this.state.formControls
                                                  .firstname,
                                                "required"
                                              )}
                                            </div>
                                          </div>
                                          <div
                                            id="wpforms-8462-field_1-container"
                                            className="wpforms-field wpforms-field-email wpforms-one-half"
                                            data-field-id="1"
                                          >
                                            <label
                                              className="wpforms-field-label"
                                              htmlFor="wpforms-8462-field_1"
                                            >
                                              Last Name{" "}
                                              <span className="wpforms-required-label">
                                                *
                                              </span>
                                            </label>
                                            <input
                                              type="text"
                                              id="wpforms-8462-field_1"
                                              className="wpforms-field-large wpforms-field-required"
                                              name="lastname"
                                              onChange={this.changeHandler}
                                            />
                                            <div className="text-danger text-left ">
                                              {this.validator.message(
                                                "lastname",
                                                this.state.formControls
                                                  .lastname,
                                                "required"
                                              )}
                                            </div>
                                          </div>

                                          <div
                                            id="wpforms-8462-field_0-container"
                                            className="wpforms-field wpforms-field-name wpforms-one-half wpforms-first"
                                            data-field-id="0"
                                          >
                                            <label
                                              className="wpforms-field-label"
                                              htmlFor="wpforms-8462-field_0"
                                            >
                                              Email
                                              <span className="wpforms-required-label">
                                                *
                                              </span>
                                            </label>
                                            <input
                                              type="email"
                                              id="wpforms-8462-field_0"
                                              className="wpforms-field-large wpforms-field-required"
                                              name="email"
                                              onChange={this.changeHandler}
                                            />
                                            <div className="text-danger text-left ">
                                              {this.validator.message(
                                                "email",
                                                this.state.formControls.email,
                                                "required|email"
                                              )}
                                            </div>
                                          </div>
                                          <div
                                            id="wpforms-8462-field_1-container"
                                            className="wpforms-field wpforms-field-email wpforms-one-half"
                                            data-field-id="1"
                                          >
                                            <label
                                              className="wpforms-field-label"
                                              htmlFor="wpforms-8462-field_1"
                                            >
                                              Phone{" "}
                                              <span className="wpforms-required-label">
                                                *
                                              </span>
                                            </label>
                                            <input
                                              type="text"
                                              id="wpforms-8462-field_1"
                                              className="wpforms-field-large wpforms-field-required"
                                              name="phone"
                                              onChange={this.changeHandler}
                                            />
                                            <div className="text-danger text-left ">
                                              {this.validator.message(
                                                "phone",
                                                this.state.formControls.phone,
                                                "required"
                                              )}
                                            </div>
                                          </div>

                                          <div
                                            id="wpforms-8462-field_0-container"
                                            className="wpforms-field wpforms-field-name wpforms-one-half wpforms-first"
                                            data-field-id="0"
                                          >
                                            <label
                                              className="wpforms-field-label"
                                              htmlFor="wpforms-8462-field_0"
                                            >
                                              Store
                                              <span className="wpforms-required-label">
                                                *
                                              </span>
                                            </label>
                                            <select
                                              name="store"
                                              className={
                                                CONFIG.DATA.THEME === 2
                                                  ? "form-control theme2"
                                                  : "form-control"
                                              }
                                              id="store"
                                              onChange={(e) =>
                                                this.changeHandler(e)
                                              }
                                            >
                                              <option value="">Select</option>
                                              {this.state.stores.map(
                                                (value, index) => (
                                                  <option
                                                    key={index}
                                                    value={
                                                      value.ClientStoreName
                                                    }
                                                  >
                                                    {value.ClientStoreName}
                                                  </option>
                                                )
                                              )}
                                            </select>
                                            <div className="text-danger text-left ">
                                              {this.validator.message(
                                                "store",
                                                this.state.formControls.store,
                                                "required"
                                              )}
                                            </div>
                                          </div>

                                          <div
                                            id="wpforms-8462-field_2-container"
                                            className="wpforms-field wpforms-field-textarea "
                                            data-field-id="2"
                                          >
                                            <label
                                              className="wpforms-field-label"
                                              htmlFor="wpforms-8462-field_2"
                                            >
                                              Comment or Message{" "}
                                              <span className="wpforms-required-label">
                                                *
                                              </span>
                                            </label>
                                            <textarea
                                              id="wpforms-8462-field_2"
                                              className="wpforms-field-medium wpforms-field-required"
                                              name="message"
                                              onChange={this.changeHandler}
                                            ></textarea>
                                            <div className="text-danger text-left ">
                                              {this.validator.message(
                                                "message",
                                                this.state.formControls.message,
                                                "required"
                                              )}
                                            </div>
                                          </div>

                                          <div
                                            className="ReCAPTCHA"
                                            style={{
                                              height: "100px",
                                              marginTop: "11px",
                                            }}
                                          >
                                            <ReCAPTCHA
                                              style={{
                                                display: "inline-block",
                                              }}
                                              theme="light"
                                              sitekey="6LebzrYUAAAAAIo_0vP7bjbtzzBTKNlC4UvyEGKU"
                                              onChange={this.handleChange}
                                              asyncScriptOnLoad={
                                                this.asyncScriptOnLoad
                                              }
                                            />
                                            <div
                                              className="text-danger text-left"
                                              style={{
                                                position: "relative",
                                                top: "-80px",
                                              }}
                                            >
                                              {this.validator.message(
                                                "captcha",
                                                this.state.formControls.Captcha,
                                                "required"
                                              )}
                                            </div>
                                          </div>

                                          <div className="wpforms-submit-container">
                                            <button
                                              type="submit"
                                              name="wpforms[submit]"
                                              className="wpforms-submit bold-title "
                                              id="wpforms-submit-8462"
                                              value="wpforms-submit"
                                              aria-live="assertive"
                                              data-alt-text="Sending..."
                                              data-submit-text="Submit"
                                              onClick={(e) => this.Contact(e)}
                                            >
                                              Submit
                                            </button>
                                          </div>
                                        </div>
                                      </form>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="entry-content">
                    <div className="vc_row wpb_row vc_row-fluid full-width">
                      <div
                        style={{
                          maxWidth: "95%",
                          textAlign: "left",
                        }}
                        className="row-container"
                      >
                        <div className="contact-form wpb_column vc_column_container vc_col-sm-7">
                          <div className="vc_column-inner pt-3 mr-3">
                            <div
                              className="wpb_wrapper"
                              style={{ marginRight: "-50px" }}
                            >
                              {this.state.storesGroups !== null ? (
                                <React.Fragment>
                                  <Col sm={11}>
                                    {Object.keys(this.state.storesGroups).map(
                                      (section_name, section_index) => {
                                        var open = 0;
                                        let storeGroup = [];
                                        if (!!section_name) {
                                          storeGroup =
                                            this.state.storesGroups[
                                            section_name
                                            ];

                                          return (
                                            <Accordion
                                              key={section_index + 1}
                                              defaultActiveKey="0"
                                            >
                                              <Card>
                                                <Card.Header>
                                                  <Accordion.Toggle
                                                    as={Accordion}
                                                    variant="link"
                                                    eventKey={section_index + 1}
                                                  >
                                                    <h4>{section_name}</h4>
                                                  </Accordion.Toggle>
                                                </Card.Header>
                                                <Accordion.Collapse
                                                  eventKey={section_index + 1}
                                                >
                                                  <Card.Body>
                                                    <Tab.Container
                                                      id="left-tabs-example"
                                                      defaultActiveKey="0"
                                                    >
                                                      <Row>
                                                        <Col
                                                          sm={3}
                                                          className="rmpassing"
                                                          style={{
                                                            paddingRight: "0px",
                                                          }}
                                                        >
                                                          <Nav
                                                            style={{
                                                              color: "#666", // marginLeft: "40px"
                                                            }}
                                                            className="flex-column"
                                                          >
                                                            {storeGroup.map(
                                                              (val, index) => {
                                                                return (
                                                                  <Nav.Item
                                                                    key={index}
                                                                  >
                                                                    <Nav.Link
                                                                      eventKey={
                                                                        index
                                                                      }
                                                                    >
                                                                      <span className="vc_tta-title-text">
                                                                        {
                                                                          val.City
                                                                        }
                                                                      </span>
                                                                    </Nav.Link>
                                                                  </Nav.Item>
                                                                );
                                                              }
                                                            )}
                                                          </Nav>
                                                        </Col>

                                                        <Col
                                                          sm={8}
                                                          style={{
                                                            borderColor:
                                                              "#f0f0f0",
                                                            backgroundColor:
                                                              "#f8f8f8",
                                                            paddingTop: "10px",
                                                            paddingBottom:
                                                              "0px",
                                                          }}
                                                        >
                                                          <Tab.Content className="contact-us">
                                                            {storeGroup.map(
                                                              (val, index) => {
                                                                return (
                                                                  <Tab.Pane
                                                                    eventKey={
                                                                      index
                                                                    }
                                                                    key={index}
                                                                  >
                                                                    <div className="row">
                                                                      <div className="col-md-6">
                                                                        <h2>
                                                                          {
                                                                            val.City
                                                                          }
                                                                        </h2>
                                                                        <p
                                                                          style={{
                                                                            marginBottom:
                                                                              "-4px",
                                                                          }}
                                                                        >
                                                                          {
                                                                            val.AddressLine1
                                                                          }
                                                                        </p>
                                                                        <p
                                                                          style={{
                                                                            marginBottom:
                                                                              "-4px",
                                                                          }}
                                                                        >
                                                                          {val.City +
                                                                            ", " +
                                                                            val.AddressLine2 +
                                                                            " " +
                                                                            val.ZipCode}
                                                                        </p>
                                                                        <p
                                                                          style={{
                                                                            marginBottom:
                                                                              "-4px",
                                                                          }}
                                                                        >
                                                                          <a
                                                                            href={
                                                                              "tel:" +
                                                                              val.StorePhoneNumber
                                                                            }
                                                                          >
                                                                            {this.formatPhoneNumber(
                                                                              val.StorePhoneNumber
                                                                            )}
                                                                          </a>
                                                                        </p>
                                                                        <p
                                                                          style={{
                                                                            marginBottom:
                                                                              "-4px",
                                                                          }}
                                                                        >
                                                                          <a
                                                                            href={
                                                                              "mailto:" +
                                                                              val.StoreEmail
                                                                            }
                                                                          >
                                                                            {
                                                                              val.StoreEmail
                                                                            }
                                                                          </a>
                                                                        </p>
                                                                        {val.StoreTimings !=
                                                                          null &&
                                                                          val.StoreTimings !=
                                                                          "" ? (
                                                                          <p
                                                                            style={{
                                                                              marginBottom:
                                                                                "-4px",
                                                                            }}
                                                                          >
                                                                            <b>
                                                                              HOURS:{" "}
                                                                            </b>
                                                                            {
                                                                              val.StoreTimings
                                                                            }
                                                                          </p>
                                                                        ) : (
                                                                          ""
                                                                        )}
                                                                      </div>
                                                                      <div className="col-md-6">
                                                                        <img
                                                                          alt="Store View"
                                                                          src={
                                                                            val.StoreImage &&
                                                                              val.StoreImage !=
                                                                              ""
                                                                              ? val.StoreImage
                                                                              : CONFIG
                                                                                .DATA
                                                                                .STORE_IMAGE
                                                                          }
                                                                        />
                                                                      </div>
                                                                      <div
                                                                        className="col-md-12 myifreme"
                                                                        style={{
                                                                          height:
                                                                            "347px",
                                                                          marginTop:
                                                                            "20px",
                                                                          borderTop:
                                                                            "0px solid lightgray",
                                                                        }}
                                                                      >
                                                                        <MapContainer
                                                                          store={
                                                                            val
                                                                          }
                                                                          h="347px"
                                                                        />
                                                                      </div>
                                                                    </div>
                                                                  </Tab.Pane>
                                                                );
                                                              }
                                                            )}
                                                          </Tab.Content>
                                                        </Col>
                                                      </Row>
                                                    </Tab.Container>
                                                  </Card.Body>
                                                </Accordion.Collapse>
                                              </Card>
                                            </Accordion>
                                          );
                                        }
                                      }
                                    )}
                                  </Col>
                                </React.Fragment>
                              ) : this.state.stores != null &&
                                this.state.stores.length > 0 ? (
                                <Tab.Container
                                  id="left-tabs-example"
                                  defaultActiveKey="0"
                                >
                                  <Row>
                                    <Col
                                      sm={3}
                                      className="rmpassing"
                                      style={{ paddingRight: "0px" }}
                                    >
                                      <Nav
                                        style={{
                                          color: "#666",
                                          // marginLeft: "40px"
                                        }}
                                        className="flex-column"
                                      >
                                        {this.state.stores.map((val, index) => {
                                          return CONFIG.DATA.RSA_SUBDOMAIN ===
                                            "tealsmarket" ? (
                                            val.ClientStoreId !== 2 ? (
                                              <Nav.Item
                                                key={index}
                                                style={
                                                  this.state.stores.length == 1
                                                    ? { opacity: "0" }
                                                    : {}
                                                }
                                              >
                                                <Nav.Link eventKey={index}>
                                                  <span className="vc_tta-title-text">
                                                    {val.City}
                                                  </span>
                                                </Nav.Link>
                                              </Nav.Item>
                                            ) : (
                                              ""
                                            )
                                          ) : (
                                            <Nav.Item
                                              key={index}
                                              style={
                                                this.state.stores.length == 1
                                                  ? { opacity: "0" }
                                                  : {}
                                              }
                                            >
                                              <Nav.Link eventKey={index}>
                                                <span className="vc_tta-title-text">
                                                  {val.City}
                                                </span>
                                              </Nav.Link>
                                            </Nav.Item>
                                          );
                                        })}
                                      </Nav>
                                    </Col>
                                    <Col
                                      sm={8}
                                      style={{
                                        borderColor: "#f0f0f0",
                                        backgroundColor: "#f8f8f8",
                                        paddingTop: "10px",
                                        paddingBottom: "0px",
                                      }}
                                    >
                                      <Tab.Content className="contact-us">
                                        {this.state.stores.map((val, index) => {
                                          return (
                                            <Tab.Pane
                                              eventKey={index}
                                              key={index}
                                            >
                                              <div className="row">
                                                <div className="col-md-6">
                                                  <h2>{val.City}</h2>
                                                  <p
                                                    style={{
                                                      marginBottom: "-4px",
                                                    }}
                                                  >
                                                    {val.AddressLine1}
                                                  </p>
                                                  <p
                                                    style={{
                                                      marginBottom: "-4px",
                                                    }}
                                                  >
                                                    {val.City +
                                                      ", " +
                                                      val.AddressLine2 +
                                                      " " +
                                                      val.ZipCode}
                                                  </p>
                                                  <p
                                                    style={{
                                                      marginBottom: "-4px",
                                                    }}
                                                  >
                                                    <a
                                                      href={
                                                        "tel:" +
                                                        val.StorePhoneNumber
                                                      }
                                                    >
                                                      {this.formatPhoneNumber(
                                                        val.StorePhoneNumber
                                                      )}
                                                    </a>
                                                  </p>
                                                  <p
                                                    style={{
                                                      marginBottom: "-4px",
                                                    }}
                                                  >
                                                    {val.City == "Annandale" ? (
                                                      <a
                                                        href={
                                                          "mailto:" +
                                                          val.StoreEmail
                                                        }
                                                      >
                                                        {val.StoreEmail}
                                                      </a>
                                                    ) : (
                                                      <a
                                                        href={
                                                          "mailto:" +
                                                          val.StoreEmail
                                                        }
                                                      >
                                                        {val.StoreEmail}
                                                      </a>
                                                    )}
                                                  </p>
                                                  {val.StoreTimings != null &&
                                                    val.StoreTimings != "" ? (
                                                    <p
                                                      style={{
                                                        marginBottom: "-4px",
                                                      }}
                                                    >
                                                      <b>HOURS: </b>
                                                      {val.StoreTimings}
                                                    </p>
                                                  ) : (
                                                    ""
                                                  )}
                                                </div>
                                                <div className="col-md-6">
                                                  <img
                                                    alt="Store View"
                                                    src={
                                                      val.StoreImage &&
                                                        val.StoreImage != ""
                                                        ? val.StoreImage
                                                        : CONFIG.DATA
                                                          .STORE_IMAGE
                                                    }
                                                  />
                                                </div>
                                                <div
                                                  className="col-md-12 myifreme"
                                                  style={{
                                                    height: "347px",
                                                    marginTop: "20px",
                                                    borderTop:
                                                      "0px solid lightgray",
                                                  }}
                                                >
                                                  <MapContainer
                                                    store={val}
                                                    h="347px"
                                                  />
                                                </div>
                                              </div>
                                            </Tab.Pane>
                                          );
                                        })}
                                      </Tab.Content>
                                    </Col>
                                  </Row>
                                </Tab.Container>
                              ) : (
                                <div className="content">
                                  <div className="overlay">
                                    <div className="overlay-content">
                                      <img
                                        style={{ maxWidth: "none" }}
                                        src="/assets/images/loading.gif"
                                        alt="Loading..."
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div
                          style={{ background: "#f8f8f8", marginLeft: "-23px" }}
                          className="contact-infor wpb_column vc_column_container mt-3 pb-3 vc_col-sm-5 vc_col-has-fill"
                        >
                          <div
                            className="vc_column-inner"
                            style={{ paddingTop: "25px" }}
                          >
                            <div className="wpb_wrapper">
                              <div className="wpb_text_column wpb_content_element ">
                                <div className="wpb_wrapper">
                                  <h2>CONTACT US</h2>
                                </div>
                              </div>
                              <div
                                className="wpforms-container wpforms-container-full"
                                id="wpforms-8462"
                              >
                                <form
                                  id="contactForm"
                                  className="wpforms-validate wpforms-form"
                                  data-formid="8462"
                                  method="post"
                                  encType="multipart/form-data"
                                  action="/contact/"
                                  noValidate="novalidate"
                                >
                                  <div className="wpforms-field-container">
                                    <div
                                      id="wpforms-8462-field_0-container"
                                      className="wpforms-field wpforms-field-name wpforms-one-half wpforms-first"
                                      data-field-id="0"
                                    >
                                      <label
                                        className="wpforms-field-label"
                                        htmlFor="wpforms-8462-field_0"
                                      >
                                        First Name
                                        <span className="wpforms-required-label">
                                          *
                                        </span>
                                      </label>
                                      <input
                                        type="text"
                                        id="wpforms-8462-field_0"
                                        className="wpforms-field-large wpforms-field-required"
                                        name="firstname"
                                        onChange={this.changeHandler}
                                      />
                                      <div className="text-danger text-left ">
                                        {this.validator.message(
                                          "firstname",
                                          this.state.formControls.firstname,
                                          "required"
                                        )}
                                      </div>
                                    </div>
                                    <div
                                      id="wpforms-8462-field_1-container"
                                      className="wpforms-field wpforms-field-email wpforms-one-half"
                                      data-field-id="1"
                                    >
                                      <label
                                        className="wpforms-field-label"
                                        htmlFor="wpforms-8462-field_1"
                                      >
                                        Last Name{" "}
                                        <span className="wpforms-required-label">
                                          *
                                        </span>
                                      </label>
                                      <input
                                        type="text"
                                        id="wpforms-8462-field_1"
                                        className="wpforms-field-large wpforms-field-required"
                                        name="lastname"
                                        onChange={this.changeHandler}
                                      />
                                      <div className="text-danger text-left ">
                                        {this.validator.message(
                                          "lastname",
                                          this.state.formControls.lastname,
                                          "required"
                                        )}
                                      </div>
                                    </div>

                                    <div
                                      id="wpforms-8462-field_0-container"
                                      className="wpforms-field wpforms-field-name wpforms-one-half wpforms-first"
                                      data-field-id="0"
                                    >
                                      <label
                                        className="wpforms-field-label"
                                        htmlFor="wpforms-8462-field_0"
                                      >
                                        Email
                                        <span className="wpforms-required-label">
                                          *
                                        </span>
                                      </label>
                                      <input
                                        type="email"
                                        id="wpforms-8462-field_0"
                                        className="wpforms-field-large wpforms-field-required"
                                        name="email"
                                        onChange={this.changeHandler}
                                      />
                                      <div className="text-danger text-left ">
                                        {this.validator.message(
                                          "email",
                                          this.state.formControls.email,
                                          "required|email"
                                        )}
                                      </div>
                                    </div>
                                    <div
                                      id="wpforms-8462-field_1-container"
                                      className="wpforms-field wpforms-field-email wpforms-one-half"
                                      data-field-id="1"
                                    >
                                      <label
                                        className="wpforms-field-label"
                                        htmlFor="wpforms-8462-field_1"
                                      >
                                        Phone{" "}
                                        <span className="wpforms-required-label">
                                          *
                                        </span>
                                      </label>
                                      <input
                                        type="text"
                                        id="wpforms-8462-field_1"
                                        className="wpforms-field-large wpforms-field-required"
                                        name="phone"
                                        onChange={this.changeHandler}
                                      />
                                      <div className="text-danger text-left ">
                                        {this.validator.message(
                                          "phone",
                                          this.state.formControls.phone,
                                          "required"
                                        )}
                                      </div>
                                    </div>

                                    <div
                                      id="wpforms-8462-field_1-container"
                                      className="wpforms-field wpforms-field-email wpforms-one-half wpforms-first"
                                      data-field-id="1"
                                    >
                                      <label
                                        className="wpforms-field-label"
                                        htmlFor="wpforms-8462-field_1"
                                      >
                                        Store{" "}
                                        <span className="wpforms-required-label">
                                          *
                                        </span>
                                      </label>
                                      <select
                                        name="store"
                                        className={
                                          CONFIG.DATA.THEME === 2
                                            ? "form-control theme2"
                                            : "form-control"
                                        }
                                        id="store"
                                        onChange={(e) => this.changeHandler(e)}
                                      >
                                        <option value="">Select</option>
                                        {this.state.stores.map(
                                          (value, index) => {
                                            if (!!value.SectionName) {
                                              return CONFIG.DATA
                                                .RSA_SUBDOMAIN ===
                                                "tealsmarket" ? (
                                                value.ClientStoreId !== 2 ? (
                                                  <option
                                                    key={index}
                                                    value={
                                                      value.ClientStoreName
                                                    }
                                                  >
                                                    {value.ClientStoreName}
                                                  </option>
                                                ) : (
                                                  ""
                                                )
                                              ) : (
                                                <option
                                                  key={index}
                                                  value={value.ClientStoreName}
                                                >
                                                  {value.ClientStoreName}
                                                </option>
                                              );
                                            } else {
                                              return CONFIG.DATA
                                                .RSA_SUBDOMAIN ===
                                                "tealsmarket" ? (
                                                value.ClientStoreId !== 2 ? (
                                                  <option
                                                    key={index}
                                                    value={
                                                      value.ClientStoreName
                                                    }
                                                  >
                                                    {value.ClientStoreName}
                                                  </option>
                                                ) : (
                                                  ""
                                                )
                                              ) : (
                                                <option
                                                  key={index}
                                                  value={value.ClientStoreName}
                                                >
                                                  {value.ClientStoreName}
                                                </option>
                                              );
                                            }
                                          }
                                        )}
                                      </select>
                                      <div className="text-danger text-left ">
                                        {this.validator.message(
                                          "store",
                                          this.state.formControls.store,
                                          "required"
                                        )}
                                      </div>
                                    </div>

                                    <div
                                      id="wpforms-8462-field_2-container"
                                      className="wpforms-field wpforms-field-textarea "
                                      data-field-id="2"
                                    >
                                      <label
                                        className="wpforms-field-label"
                                        htmlFor="wpforms-8462-field_2"
                                      >
                                        Comment or Message{" "}
                                        <span className="wpforms-required-label">
                                          *
                                        </span>
                                      </label>
                                      <textarea
                                        id="wpforms-8462-field_2"
                                        className="wpforms-field-medium wpforms-field-required"
                                        name="message"
                                        onChange={this.changeHandler}
                                      ></textarea>
                                      <div className="text-danger text-left ">
                                        {this.validator.message(
                                          "message",
                                          this.state.formControls.message,
                                          "required"
                                        )}
                                      </div>
                                    </div>

                                    <div
                                      className="ReCAPTCHA"
                                      style={{
                                        height: "100px",
                                        marginTop: "11px",
                                      }}
                                    >
                                      <ReCAPTCHA
                                        style={{ display: "inline-block" }}
                                        theme="light"
                                        sitekey="6LebzrYUAAAAAIo_0vP7bjbtzzBTKNlC4UvyEGKU"
                                        onChange={this.handleChange}
                                        asyncScriptOnLoad={
                                          this.asyncScriptOnLoad
                                        }
                                      />
                                      <div
                                        className="text-danger text-left"
                                        style={{
                                          position: "relative",
                                          top: "-80px",
                                        }}
                                      >
                                        {this.validator.message(
                                          "captcha",
                                          this.state.formControls.Captcha,
                                          "required"
                                        )}
                                      </div>
                                    </div>

                                    <div className="wpforms-submit-container">
                                      <button
                                        type="submit"
                                        name="wpforms[submit]"
                                        className="wpforms-submit bold-title "
                                        id="wpforms-submit-8462"
                                        value="wpforms-submit"
                                        aria-live="assertive"
                                        data-alt-text="Sending..."
                                        data-submit-text="Submit"
                                        onClick={(e) => this.Contact(e)}
                                      >
                                        Submit
                                      </button>
                                    </div>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </article>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Contact;
